import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8yqw6Nlll_3eMhJUHCaEUJCfE_MNpXzM",
  authDomain: "church-receipts-sda.firebaseapp.com",
  projectId: "church-receipts-sda",
  storageBucket: "church-receipts-sda.firebasestorage.app",
  messagingSenderId: "172614315880",
  appId: "1:172614315880:web:862d15559bbebc6acaf0dd",
  measurementId: "G-4ZFB05HERW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);